<template>
  <ion-page>
    <ion-content
      fullscreen="true"
      class="eventpage"
      :style="contentBackgroundStyle"
      :scroll-events="enableScrollEvent"
      @ionScroll="onScroll"
    >
      <main>
        <div
          class="w-full h-full min-h-screen"
          :class="{
            'bg-[#3C3A36] text-white': !isLightMode,
            'bg-[#F6F4F0] text-black': isLightMode,
          }"
        >
          <slot class="flex-1 page-bottom-padding" test="test"> </slot>
        </div>
      </main>
    </ion-content>
  </ion-page>
</template>

<script>
import { IonPage, IonContent } from '@ionic/vue';
import { mapState } from 'vuex';
import { lockToPortrait } from '@/utils/screen-orientation';

export default {
  name: 'EventPageLayout',
  components: {
    IonPage,
    IonContent,
  },
  props: {
    enableScrollEvent: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('eventPage', ['isLightMode']),
    contentBackgroundStyle() {
      const backgroundColor = this.isLightMode ? '#F6F4F0' : '#3C3A36';

      return {
        '--background': backgroundColor,
        '--background-color': backgroundColor,
        background: backgroundColor,
      };
    },
  },
  methods: {
    onScroll(event) {
      this.$emit('on-scroll', event);
    },
  },
  async mounted() {
    await lockToPortrait();
  },
  async beforeUnmount() {
    await lockToPortrait();
  },
};
</script>
